<template lang="pug">
    
    v-dialog(
        v-model="uploadsDialog"
        max-width="500"
        class="full-width w-dialog"
        persistent
    )
        v-card
            .text-xs-right
                v-btn(
                    icon
                    @click="close"
                )
                    v-icon mdi-close
            div( v-if="uploadsLoading")
                fan-loader(
                    :loading="uploadsLoading"
                )
                    div(slot="loadingMsg" 
                        class="full-width text-xs-center headline my-2") Fetching images...
            

            template(v-if="!uploadsLoading")
            
                ImageUpload(
                    v-if="uploading"
                    :applicationId ="applicationId"
                    :lender="lender"
                    @finishedSaving="toggleSaveState"
                    @registerError="setError"
                    @turnUploadingOff="uploading = false"
                    :helperText="helperText"
                )

                div(v-else-if="uploadState === 'DEFAULT'" style="height: 400px" )
                    .display-1 Image Uploads
                    .caption.my-3 {{ helperText }}
                    .body-2.ma-3(style="padding-top: 25%") Currently, there are no images available
            

                div(v-else-if="uploadState === 'UPLOADS'")
                    .display-1 Uploaded Images
                    .caption.my-3 {{ helperText }}
                    template(v-if="arrayOfUploads.length > 1")
                        v-carousel.mt-3(hide-delimiters :cycle="false" light)
                            v-carousel-item.mx-5(
                            v-for="(upload, u) in arrayOfUploads"
                            :key="u"
                            :src="upload.url"
                        )
                    template(v-else)
                        v-img(
                            :src="arrayOfUploads[0].url"
                        )

                div(v-else-if="uploadState === 'SAVED'")
                    Success(
                        :src="saveCheck"
                    ) 
                        | Your images have been saved.
                        .body-2.pt-5 You can now close this window.

                v-card-text.mb-5.title(
                    v-else-if="uploadState === 'ERROR'"
                )
                    | {{ errMsg }}


                v-btn.ma-3(
                    v-show="!uploading"
                    class="primary"
                    @click="uploadImage()"
                ) Upload Images
</template>

<script>
import FanLoader from 'Components/FanLoader.vue'
import ImageUpload from '@/components/ImageUpload'
import Success from '@/components/dialogs/Success'
import { delayMilliseconds } from 'Helpers/utilFunctions.js'
import { mapActions } from 'vuex'

export default {
    components: {
        ImageUpload, 
        Success,
        FanLoader,
    },
    data: () => ({
        errMsg: '',
        saveCheck: require('@/assets/successgif.gif'),
        uploadsLoading: true,
        uploading: null,
        arrayOfUploads: null,
        uploadsSaved: false
    }),
    props: {
        uploadsDialog: Boolean,
        applicationId: String,
        lender: String,
    },
    computed: {
        uploadState() {
        if(!this.uploading && !this.uploadsSaved && !this.errMsg && (!this.arrayOfUploads || !this.arrayOfUploads.length)){
            return 'DEFAULT'
        } else if (!this.uploading && !this.errMsg && this.arrayOfUploads && !this.uploadsSaved) {
            return 'UPLOADS'
        } else if (this.uploadsSaved && !this.errMsg){
            return 'SAVED'
        } else if (this.errMsg){
            return 'ERROR'
        } else return 'DEFAULT'
        },
        helperText() {
            return 'Keep track of your completed jobs for future reference.'
        } 
    },
    watch: {
        async uploadsDialog(val) {
            if (val) {
                const result = await this.getUploadedImages({lender: this.lender, applicationId: this.applicationId})
                this.arrayOfUploads = result.data.images
                this.uploadsLoading = false
            }
        }
    },
    methods: {
        ...mapActions([
            'getUploadedImages'
        ]),
        async close() {
            this.$emit('close')
            await delayMilliseconds(500)
            this.arrayOfUploads = null
            this.uploadsLoading = true
            this.uploadsSaved = false
        },
        uploadImage() {
            console.log("Ready to Upload")
            this.uploading = true
        },
        toggleSaveState(){
            this.uploading = false
            this.uploadsSaved = true
            this.uploadsLoading = false
        },
        setError(message){
            this.uploading = false
            if(message.includes("request entity to large")){
                this.errMsg = "Sorry, your image is too large to upload. Please try a smaller image size"
            } else {
                this.errMsg = message
            }
            this.uploadsSaved = true
        }
    }, 
}
</script>

<style lang="scss" scoped>

 .v-carousel {
    box-shadow: none;
}

</style>